import { render, staticRenderFns } from "./new_login.vue?vue&type=template&id=6e3b6547"
import script from "./new_login.vue?vue&type=script&lang=js"
export * from "./new_login.vue?vue&type=script&lang=js"
import style0 from "./new_login.vue?vue&type=style&index=0&id=6e3b6547&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports